import { useState, useEffect } from 'react';
import Select from 'components/Select';
import Button from 'components/Button';

const UserShift = ({ groups, group, onShift }) => {
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    if (!groupName && group?.Name) {
      setGroupName(group?.Name);
    }
  }, [groupName, group]);

  const disabled = !groupName || group?.Name === groupName;

  return (
    <div
      style={{
        display: 'grid',
        margin: 10,
        gridColumnGap: 20,
        gridTemplateColumns: '0.5fr 0.5fr',
      }}>
      <Select
        options={groups}
        labelKey='name'
        valueKey='name'
        value={{ name: groupName }}
        onChange={(v) => setGroupName(v)}
      />
      <Button
        title='Shift'
        disabled={disabled}
        containerStyle={{
          backgroundColor: '#000',
          color: 'white',
          opacity: disabled ? 0.5 : 1,
        }}
        onClick={() => onShift(groupName)}
      />
    </div>
  );
};

export default UserShift;
